// Toasts
export const ADD_TOAST = 'toasts/ADD_TOAST';
export const REMOVE_TOAST = 'toasts/REMOVE_TOAST';


// WEBPACK FOOTER //
// ./resources/assets/js/shared/store/mutation-types.js